import { JSX, SVGProps } from 'react';

export const Hydrogen = (props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={85.333}
    height={90.667}
    viewBox="0 0 64 68"
    {...props}
  >
    <path d="M25.8 2.6C23.1 3.9 21 5.4 21 5.8s2.3 1.8 5 3.1c2.8 1.3 5.3 2.7 5.5 3.1s-1.6 1.8-4.1 3l-4.5 2.3-4.2-2.3c-2.3-1.3-5-2.8-5.9-3.4-1.4-.8-3-.4-7.3 1.9-3 1.7-5.5 3.3-5.5 3.7s6.7 4.2 15 8.5c8.2 4.3 15 8 15 8.4 0 .3-2 1.5-4.5 2.7s-4.5 2.5-4.5 3c0 .4 2.6 2.1 5.7 3.6l5.8 2.8-4.8 2.4-4.7 2.5-5.9-3.3-6-3.3-5.5 2.7C2.5 48.7 0 50.4 0 50.9 0 51.8 30.1 68 31.9 68S43 63.1 43 62.2c0-.5-2.2-1.9-5-3.2-2.7-1.3-5-2.6-5-3 0-.3 1.9-1.5 4.3-2.7l4.3-2.1 5.8 3.1 5.8 3.1 5.4-2.9c3-1.6 5.4-3.3 5.4-3.7s-6.7-4.2-15-8.5c-8.2-4.3-15-8-15-8.4 0-.3 2.1-1.5 4.6-2.7 5.3-2.6 5-3.7-1.6-6.7-4.5-2-4.4-2.7.8-5.4l3.7-1.9 5.5 3.1 5.6 3 5.7-2.6c3.1-1.4 5.7-3 5.7-3.4 0-.5-1.7-1.7-3.7-2.8-2.1-1.1-8.9-4.8-15.3-8.2C38.7 2.8 32.8 0 32 .1c-.8 0-3.6 1.1-6.2 2.5" />
  </svg>
);
